import React, { useState, useEffect } from 'react';
import { Logger } from 'stores/Classes';
import { Form, Col, DatePicker, Space, Input, Select, InputNumber } from 'antd';

import {
  ShopStore,
  CurrentUserStore,
  InspectionsStore,
  UserStore,
  CarStore,
} from 'stores';

const { Option } = Select;

const Asset = ({ form }) => {
  const [cars, setCars] = useState([]);
  const [assetType, setAssetType] = useState('vehicle');

  const typeWatched = Form.useWatch('assetType', form) ?? 'vehicle';

  useEffect(() => {
    const initialize = async () => {
      await loadData(ShopStore.currentShop.id);
    };

    initialize();
  }, []);

  useEffect(() => {
    setAssetType(typeWatched);
  }, [typeWatched]);

  const loadData = async (shopId) => {
    try {
      const cars = await CarStore.getShopCarsBasicInfoAndReturn(shopId);

      setCars(cars);
    } catch (e) {
      Logger.log(e);
    }
  };

  const assetOptions = cars
    .filter((car) => car.carType === assetType.toLowerCase())
    .map((car) => ({
      label: `${car.unitId} - ${car.vin}`,
      value: car.id,
    }));

  const onChange = (value) => {
    const car = cars.find((car) => car.id === value);
    form.setFieldsValue({
      vin: car?.vin,
      mileage: Number(car?.totalMileage) || 0,
      engineHours: car?.engineHourInSeconds / 3600,
    });
  };

  const onChangeType = (value) => {
    setAssetType(value);
    const selectedAsset = form.getFieldValue('asset');

    const car = cars.find((car) => car.id === selectedAsset);

    if (value !== car.carType) {
      form.setFieldsValue({
        asset: undefined,
        vin: undefined,
        mileage: undefined,
        engineHours: undefined,
      });
    }
  };

  return (
    <>
      <Col span={12}>
        <Form.Item
          label="Asset Type"
          required
          name="assetType"
          rules={[{ required: true, message: 'Type is required' }]}
          style={{ marginBottom: 10 }}
        >
          <Select placeholder="Asset Type" onChange={onChangeType}>
            <Option value="vehicle">Vehicle</Option>
            <Option value="trailer">Trailer</Option>
            <Option value="other">Other</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Select Asset"
          required
          name="asset"
          rules={[{ required: true, message: 'Asset is required' }]}
          style={{ marginBottom: 10 }}
        >
          <Select
            showSearch
            placeholder="Select a Asset"
            optionFilterProp="label"
            onChange={onChange}
            options={assetOptions}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="VIN"
          required
          name="vin"
          rules={[{ required: true, message: 'VIN is required' }]}
          style={{ marginBottom: 10 }}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Client" name="client" style={{ marginBottom: 8 }}>
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Mileage"
          required
          name="mileage"
          rules={[{ required: true, message: 'Mileage is required' }]}
          style={{ marginBottom: 10 }}
        >
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            precision={2}
            formatter={(value) => {
              if (!value) return '';
              const num = parseFloat(value);
              return isNaN(num) ? '' : num.toFixed(2);
            }}
            parser={(value) => {
              const cleaned = value.replace(/[^\d.]/g, '');
              const parts = cleaned.split('.');
              return parts.length > 2
                ? `${parts[0]}.${parts.slice(1).join('')}`
                : cleaned;
            }}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Engine Hours"
          required
          name="engineHours"
          rules={[{ required: true, message: 'Engine Hours is required' }]}
          style={{ marginBottom: 10 }}
        >
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            precision={2}
            formatter={(value) => {
              if (!value) return '';
              const num = parseFloat(value);
              return isNaN(num) ? '' : num.toFixed(2);
            }}
            parser={(value) => {
              const cleaned = value.replace(/[^\d.]/g, '');
              const parts = cleaned.split('.');
              return parts.length > 2
                ? `${parts[0]}.${parts.slice(1).join('')}`
                : cleaned;
            }}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default Asset;
